<template>
  <div class="partner-band" id="partners">
    <div class="partner-inner">
      <div class="left">
        <span class="eyebrow">Partners</span>
        <h2>Met enorm veel dank aan onze partners</h2>
        <p>
          Partnerships vormen de belangrijkste bron van inkomsten. Financiële
          bijdragen worden alleen gebruikt voor externe kosten, niet voor de
          interne organisatie. Ziet u het belang van WeShare4Kids en wilt u
          bijdragen? Heel graag!
        </p>
        <button class="partner-cta" @click="$router.push('/steunons')">
          Wil jij ook partner worden? →
        </button>
      </div>
      <div class="right">
        <button
          class="partner-card"
          v-for="(s, index) in partners"
          :key="index"
          :aria-label="`Bezoek de website van ${s.name}`"
          @click="openUrl(s.url)"
        >
          <v-img
            width="100%"
            contain
            :src="getImgUrl(s.src)"
            :alt="s.name"
          ></v-img>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      partners: [
        {
          name: "Micazu",
          url: "https://www.micazu.nl/",
          src: "micazu.jpg",
        },
        {
          name: "Rabobank",
          url: "https://www.rabobank.nl/",
          src: "rabobank.webp",
        },
        {
          name: "Huijbregts Notarissen",
          url: "https://www.huijbregtsnotarissen.com/",
          src: "huijbregts.svg",
        },
        {
          name: "Holla Advocaten",
          url: "https://www.holla.nl/",
          src: "holla.jpg",
        },
        { name: "BDO", url: "https://www.bdo.nl/", src: "BDO.svg" },
        { name: "Claeren", url: "https://www.claeren.nl/", src: "claeren.png" },
      ],
    };
  },
  methods: {
    getImgUrl(src) {
      return require("@/assets/partners/" + src);
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.partner-band {
  background: linear-gradient(150deg, #3b2415, #4a2c18);
}
.partner-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 72px 32px;
  display: grid;
  grid-template-columns: 0.85fr 1.15fr;
  gap: 56px;
  align-items: center;
}
.left {
  .eyebrow {
    font-family: "Nunito", sans-serif;
    font-weight: 800;
    font-size: 13.5px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #f7a86a;
    display: block;
  }
  h2 {
    font-family: "Nunito", sans-serif;
    font-weight: 900;
    font-size: 36px;
    line-height: 1.12;
    letter-spacing: -0.02em;
    color: #fff;
    margin: 12px 0 18px;
  }
  p {
    font-size: 16px;
    line-height: 1.65;
    color: rgba(255, 255, 255, 0.76);
    margin-bottom: 26px;
  }
}
.partner-cta {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 16px;
  color: #fff;
  background: #ea6b26;
  border: none;
  cursor: pointer;
  padding: 14px 26px;
  border-radius: 14px;
  box-shadow: 0 10px 26px rgba(234, 107, 38, 0.4);
  transition: background var(--ws-dur-fast) var(--ws-ease-out),
    transform var(--ws-dur-press) var(--ws-ease-out);
}
@media (hover: hover) and (pointer: fine) {
  .partner-cta:hover {
    background: #f2792f;
    transform: translateY(-2px);
  }
}
.partner-cta:active {
  transform: scale(0.97);
}
.right {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}
.partner-card {
  background: #fff;
  border: none;
  border-radius: 16px;
  aspect-ratio: 3/2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  cursor: pointer;
  box-shadow: 0 10px 30px -16px rgba(0, 0, 0, 0.5);
  transition: transform var(--ws-dur-fast) var(--ws-ease-out),
    box-shadow var(--ws-dur-fast) var(--ws-ease-out);
}
@media (hover: hover) and (pointer: fine) {
  .partner-card:hover {
    transform: translateY(-3px);
  }
}
.partner-card:active {
  transform: translateY(-1px) scale(0.98);
}

@media screen and (max-width: 900px) {
  .partner-inner {
    grid-template-columns: 1fr;
    gap: 36px;
    padding: 56px 24px;
  }
}
@media screen and (max-width: 600px) {
  .right {
    grid-template-columns: 1fr 1fr;
  }
  .left h2 {
    font-size: 28px;
  }
}
</style>
